import React, { forwardRef } from "react";
import { FacModalProps } from "./FacModal.type";
import FacModalRoot, { FacModalBody, FacModalHeader, FacModalWrapper } from "./FacModal.styles";
import { IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

export const FacModal = forwardRef<HTMLDivElement, FacModalProps>(
    ({ children, title, className, enable, setEnable, ...props }, ref) => (
        <FacModalRoot
            ref={ref}
            className={`FacModal-root FacModal-root--${enable ? "enabled" : "disabled"} ${className}`}
            {...props}
        >
            <FacModalWrapper
                className={`FacModal-wrapper FacModal-wrapper--${enable ? "enabled" : "disabled"}`}
            >
                <FacModalHeader className="FacModal-header">
                    <Typography color="primary.dark" variant="h3">
                        {title}
                    </Typography>
                    <IconButton onClick={() => setEnable(false)} className="FacModal-header-close">
                        <Close />
                    </IconButton>
                </FacModalHeader>
                <FacModalBody className="FacModal-body">{children}</FacModalBody>
            </FacModalWrapper>
        </FacModalRoot>
    ),
);

FacModal.displayName = "FacModalComponent";

export default FacModal;
